

const MexicanRegions = (props) => {
  const {
    handleChange,
    value,
    className = 'form-select'
  } = props;

  return (
    <select
      value={value}
      name='state'
      onChange={handleChange}
      data-label="State/Province" class={className} data-field-type="State">

      <option value="">Choose a State/Province</option>
      <option value="Aguascalientes">Aguascalientes</option> <option value="Baja California">Baja California</option> <option value="Baja California Sur">Baja California Sur</option> <option value="Campeche">Campeche</option> <option value="Chiapas">Chiapas</option> <option value="Chihuahua">Chihuahua</option> <option value="Ciudad de México">Ciudad de México</option> <option value="Coahuila">Coahuila</option> <option value="Colima">Colima</option> <option value="Durango">Durango</option> <option value="Guanajuato">Guanajuato</option> <option value="Guerrero">Guerrero</option> <option value="Hidalgo">Hidalgo</option> <option value="Jalisco">Jalisco</option> <option value="México">México</option> <option value="Michoacán">Michoacán</option> <option value="Morelos">Morelos</option> <option value="Nayarit">Nayarit</option> <option value="Nuevo León">Nuevo León</option> <option value="Oaxaca">Oaxaca</option> <option value="Puebla">Puebla</option> <option value="Querétaro">Querétaro</option> <option value="Quintana Roo">Quintana Roo</option> <option value="San Luis Potosí">San Luis Potosí</option> <option value="Sinaloa">Sinaloa</option> <option value="Sonora">Sonora</option> <option value="Tabasco">Tabasco</option> <option value="Tamaulipas">Tamaulipas</option> <option value="Tlaxcala">Tlaxcala</option> <option value="Veracruz">Veracruz</option> <option value="Yucatán">Yucatán</option> <option value="Zacatecas">Zacatecas</option></select>
  )
}

const CanadianRegions = (props) => {
  const {
    value,
    handleChange,
    className = 'form-select'
  } = props
  return (
    <select
      value={value}
      name='state'
      onChange={handleChange}
      data-label="State/Province" class={className} data-field-type="State"><option value="">Choose a State/Province</option> <option value="Alberta">Alberta</option> <option value="British Columbia">British Columbia</option> <option value="Manitoba">Manitoba</option> <option value="New Brunswick">New Brunswick</option> <option value="Newfoundland and Labrador">Newfoundland and Labrador</option> <option value="Northwest Territories">Northwest Territories</option> <option value="Nova Scotia">Nova Scotia</option> <option value="Nunavut">Nunavut</option> <option value="Ontario">Ontario</option> <option value="Prince Edward Island">Prince Edward Island</option> <option value="Quebec">Quebec</option> <option value="Saskatchewan">Saskatchewan</option> <option value="Yukon Territory">Yukon Territory</option></select>
  )
}



const AmericanRegions = (props) => {

  const {
    value,
    handleChange,
    className = 'form-select',
    initialValue
  } = props;
  return (
    <select
      value={value}
      name='state'
      onChange={handleChange}
      data-label="State/Province" class={className} data-field-type="State">
      <option value="">{initialValue || 'Choose a State/Province'}</option>
      <option value="AL">Alabama</option>
      <option value="AK">Alaska</option>
      <option value="AS">American Samoa</option>
      <option value="AZ">Arizona</option>
      <option value="AR">Arkansas</option>
      <option value="Armed Forces Africa">Armed Forces Africa</option>
      <option value="Armed Forces Americas">Armed Forces Americas</option>
      <option value="Armed Forces Canada">Armed Forces Canada</option>
      <option value="Armed Forces Europe">Armed Forces Europe</option>
      <option value="Armed Forces Middle East">Armed Forces Middle East</option>
      <option value="Armed Forces Pacific">Armed Forces Pacific</option>
      <option value="CA">California</option>
      <option value="CO">Colorado</option>
      <option value="CT">Connecticut</option>
      <option value="DE">Delaware</option>
      <option value="DC">District of Columbia</option>
      <option value="Federated States Of Micronesia">Federated States Of Micronesia</option>
      <option value="FL">Florida</option>
      <option value="GA">Georgia</option>
      <option value="GU">Guam</option>
      <option value="HI">Hawaii</option>
      <option value="ID">Idaho</option>
      <option value="IL">Illinois</option>
      <option value="IN">Indiana</option>
      <option value="IA">Iowa</option>
      <option value="KS">Kansas</option>
      <option value="KY">Kentucky</option>
      <option value="LA">Louisiana</option>
      <option value="ME">Maine</option>
      <option value="Marshall Islands">Marshall Islands</option>
      <option value="MD">Maryland</option>
      <option value="MA">Massachusetts</option>
      <option value="MI">Michigan</option>
      <option value="MN">Minnesota</option>
      <option value="MS">Mississippi</option>
      <option value="MO">Missouri</option>
      <option value="MT">Montana</option>
      <option value="NE">Nebraska</option>
      <option value="NV">Nevada</option>
      <option value="NH">New Hampshire</option>
      <option value="NJ">New Jersey</option>
      <option value="NM">New Mexico</option>
      <option value="NY">New York</option>
      <option value="NC">North Carolina</option>
      <option value="ND">North Dakota</option>
      <option value="MP">Northern Mariana Islands</option>
      <option value="OH">Ohio</option>
      <option value="OK">Oklahoma</option>
      <option value="OR">Oregon</option>
      <option value="Palau">Palau</option>
      <option value="PA">Pennsylvania</option>
      <option value="PR">Puerto Rico</option>
      <option value="RI">Rhode Island</option>
      <option value="SC">South Carolina</option>
      <option value="SD">South Dakota</option>
      <option value="TN">Tennessee</option>
      <option value="TX">Texas</option>
      <option value="UT">Utah</option>
      <option value="VT">Vermont</option>
      <option value="VI">Virgin Islands</option>
      <option value="VA">Virginia</option>
      <option value="WA">Washington</option>
      <option value="WV">West Virginia</option>
      <option value="WI">Wisconsin</option>
      <option value="WY">Wyoming</option></select>
  )
}
const RegionSelect = (props) => {

  const {
    value,
    country = 'United States',
    handleChange,
    className,
    initialValue
  } = props;

  const Region = country === 'United States' ?
    AmericanRegions : (
      country === 'Canada' ?
        CanadianRegions : (
          country === 'Mexico' ?
            MexicanRegions :
            undefined
        )
    )

  return Region ?
    <Region
      value={value}
      className={className}
      handleChange={handleChange}
      initialValue={initialValue}
    />
    :
    <input
      value={value}
      className={className || 'form-input'}
      onChange={handleChange}
      name='state'
      placeholder='Province/State*'
    />
}

export default RegionSelect;